import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

import './styles.css'
import { initSentry, setFormContext } from './lib/sentry'
import { captureUrlAttribution, initAttributionListener } from './lib/iframe-messaging'
import { ErrorBoundary } from './components/ErrorBoundary'

// Initialize Sentry FIRST before any other code
initSentry()

// Start listening for attribution data from parent window as early as possible
initAttributionListener()

// Seed attribution from this window's URL params + referrer (covers direct links
// like Instagram bios or Google Ads landing pages where there's no embedding parent)
captureUrlAttribution()

// Extract form context from URL params and set in Sentry
try {
  const params = new URLSearchParams(window.location.search)
  setFormContext({
    formId: params.get('formId') || undefined,
    organizationId: params.get('orgId') || undefined,
    sourceUrl: document.referrer || undefined,
  })
} catch (e) {
  // Ignore cross-origin errors when accessing document.referrer
  console.debug('Could not set form context:', e)
}

// Create a new router instance
const router = createRouter({
  routeTree,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Render the app
const rootElement = document.getElementById('root')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </StrictMode>,
  )
}

